import { Transcription } from '.';

export const getCurrentTranscriptionIndex = (
  transcriptions: Transcription[] | undefined,
  videoTime: number,
) => {
  const transcriptionIndex = transcriptions?.findIndex(
    transcription =>
      (videoTime >= transcription.resultStartTime && videoTime <= transcription.resultEndTime) ||
      videoTime < transcription.resultStartTime,
  );
  return transcriptionIndex || 0;
};
